import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class CancelReasonsService {

  constructor(private http: HttpClient) { }
  
    save(id: any, payload: any){
      if(id){
        return this.http.patch(urls.API_URL + urls.CHANGE_REASON + `/${id}`, payload)
        .pipe(catchError(errorHandl));
      }
      return this.http.post(urls.API_URL + urls.CHANGE_REASON, payload)
        .pipe(catchError(errorHandl));
    }
  
    get(queryParams? : any){
      const params = new HttpParams({fromObject : queryParams})
      return this.http.get(urls.API_URL + urls.CHANGE_REASON, {params})
       .pipe(catchError(errorHandl));
    }
  
    getById(id: any){
      return this.http.get(urls.API_URL + urls.CHANGE_REASON + `/${id}`)
      .pipe(catchError(errorHandl));
    }
    picker(queryParams?:any){
      const params = new HttpParams({fromObject : queryParams})
      return this.http.get(urls.API_URL + urls.CHANGE_REASON + '/picker', {params})
       .pipe(catchError(errorHandl));
    }
}
